import VanillaTilt from "vanilla-tilt";
import { gsap } from "gsap";

// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);
